import styled from 'styled-components'

const OuterContainer = styled.div`
  margin-top: 10px;
  display: grid;
  justify-items: center;
`

const InnerContainer = styled.div`
  display: grid;
  grid-template-columns: min-content 1fr;
  align-items: center;
  grid-gap: 10px;
  cursor: pointer;
`

interface Props {
  onClick: () => void
}

const FooterBackButton = ({ onClick }: Props) => (
  <OuterContainer>
    <InnerContainer onClick={onClick}>
      <img src="/assets/svg/user.svg" alt="an outline eillustration of a person" /> Back
      to dashboard
    </InnerContainer>
  </OuterContainer>
)

export default FooterBackButton
